/**
 * @desc 时效告警-详情
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response =
  defs.basics.ResponseDto<defs.basics.TimelinessDashboardWarnRecordResponseDto>;
export function request(id: number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/timelinessDashboardWarnRecord/details/${id}`, {
      method: "GET",

      ...options,
    }),
  );
}
